<template>
    <!-- transition 这里可以加一些简单的动画效果 -->
    <transition name="fade" enter-class="fade-in-enter" enter-active-class="fade-in-active" leave-class="fade-out-enter"
        leave-active-class="fade-out-active">
        <!--style 通过props 控制内容的样式  -->
        <div class="dialog-cover" v-if="isShow" @click="close">
            <div class="dialog-content" @click.stop="doSomething($event)">
                <div class="dialog_head">
                    <!--弹窗头部 title-->
                    <slot name="header"></slot>
                </div>
                <div class="dialog_main">
                    <!--弹窗的内容-->
                    <slot name="main">弹窗内容</slot>
                </div>
                <!--弹窗关闭按钮-->
                <div class="footer">
                    <button class="close" @click="close">取消</button>
                    <button class="ok openApp" @click="ok">确定</button>
                </div>
            </div>

        </div>
    </transition>
</template> 

<script>
/** 弹窗组件*/
export default {
    name: "dialog",
    props: {
        isShow: {
            type: Boolean,
            default: false,
            required: true
        },
        params: {
            type: Object,
            default: () => { }
        }
    },
    updated () {
        let _this = this;
        this.$nextTick(() => {
            new JMLink([
                {
                    jmlink: 'https://bciq41.jglinks.cn/Aan7',//短链地址 
                    button: document.querySelectorAll('button.openApp'),
                    autoLaunchApp: false,
                    autoRedirectToDownloadUrl: true,
                    downloadWhenUniversalLinkFailed: false,
                    inapp: false,
                    params: _this.params,
                    plhparams: _this.params,
                },
            ]);
        })
    },
    methods: {
        doSomething (event) {
            // console.log(event)
        },
        close () {
            this.$emit("on-close");
        },
        ok () {
            // this.$emit("on-ok");
        }
    }
};
</script>
<style lang="less" scoped>
/** 弹窗动画*/
.fade-in-active,
.fade-out-active {
    transition: all 0.5s ease
}

.fade-in-enter,
.fade-out-active {
    opacity: 0
}

.dialog-cover {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000000;
    background: rgba(0, 0, 0, 0.5);

    .dialog-content {
        width: 560px;
        height: 300px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background: #FFFFFF;
        overflow: hidden;
        border-radius: 16px;

        .dialog_head {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .dialog_main {
            // 主体内容样式设置
            background: #ffffff;
            display: flex;
            justify-content: center;
            align-content: center;
            padding: 22px 0 47px 0;
        }

        .footer {
            display: flex;
            justify-content: space-between;
            height: 112px;
            line-height: 112px;
            letter-spacing: 0;
            border-top: 2px solid #F6F6F6;

            .close {
                flex: 1;
                font-size: 32px;
                color: #C4C8D4;
                border-right: 2px solid #F6F6F6;
            }

            .ok {
                flex: 1;
                font-size: 32px;
                color: #007AFF;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// dialog.vue?d9a0f08a